export default __webpack_public_path__ + "static/media/illustration-algohealth-m@2x.bf270d80.webp";